// extracted by mini-css-extract-plugin
module.exports = {"emptyList":"styles_emptyList__3mnaq","messagesListing":"styles_messagesListing__2NS8a"};